<template>
  <div style="padding: 10px">
    <!-- PC端搜索 -->
    <div class="search-pc" style="margin: 10px 0">
      <el-select v-model="search.roleId" placeholder="选择角色" style="width: 20%" clearable filterable>
        <el-option v-for="role in roleList" :key="role.roleId" :label="`${role.accountName} (${role.roleId})`" :value="role.roleId"></el-option>
      </el-select>
      <el-select v-model="search.logType" placeholder="日志类型" style="width: 20%" clearable>
        <el-option v-for="item in logTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="search.error" placeholder="异常报错" style="width: 20%" clearable>
        <el-option v-for="item in errorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>
    
    <!-- 移动端搜索 -->
    <div class="search-mobile">
      <div class="search-header" @click="searchCollapsed = !searchCollapsed">
        <span>搜索筛选</span>
        <i :class="searchCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
      </div>
      <div class="search-content" v-show="!searchCollapsed">
        <el-select v-model="search.roleId" placeholder="选择角色" clearable filterable>
          <el-option v-for="role in roleList" :key="role.roleId" :label="`${role.accountName} (${role.roleId})`" :value="role.roleId"></el-option>
        </el-select>
        <el-select v-model="search.logType" placeholder="日志类型" clearable>
          <el-option v-for="item in logTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="search.error" placeholder="异常报错" clearable>
          <el-option v-for="item in errorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div class="search-btns">
          <el-button type="primary" @click="load">查询</el-button>
          <el-button @click="resetData">重置</el-button>
        </div>
      </div>
    </div>

    <!-- PC端表格 -->
    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" class="table-pc">
      <el-table-column prop="accountName" label="角色名" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="tokenId" label="角色Token" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="content" label="日志内容"></el-table-column>
      <el-table-column prop="logTime" label="时间" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="logType" label="日志类型" :formatter="formatLogType" width="150" show-overflow-tooltip></el-table-column>
    </el-table>
    
    <!-- 移动端卡片 -->
    <div class="table-mobile" v-loading="loading">
      <div class="card-item" v-for="item in tableData" :key="item.id">
        <div class="card-row">
          <span class="card-label">角色名：</span>
          <span class="card-value">{{ item.accountName }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">时间：</span>
          <span class="card-value">{{ item.logTime }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">类型：</span>
          <span class="card-value">{{ formatLogType(item, null, item.logType) }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">内容：</span>
          <span class="card-value content-text">{{ item.content }}</span>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination class="pagination-pc" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[5, 10, 20]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-pagination class="pagination-mobile" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'wsLog',
  data() {
    return {
      dialogVisible: false,
      form: { createTime: '' },
      userId: '',
      loading: true,
      search: { roleId: '', logType: '', error: '' },
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      roleList: [],
      logTypeOptions: [],
      errorOptions: [
        {label: '是', value: 1},
        {label: '否', value: 0}
      ],
      logTypeMap: {},
      searchCollapsed: true
    }
  },
  created() {
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
    this.loadRoleList();
    this.loadLogTypes();
    this.load();
  },
  methods: {
    loadRoleList() {
      request.get("/accountInfoWs/listResponse", {
        params: { current: 1, size: 1000 }
      }).then(res => {
        if (res.code === '0' && res.data) {
          if (Array.isArray(res.data.records)) {
            this.roleList = res.data.records.filter(item => item.roleId).map(item => ({
              id: item.id,
              accountName: item.accountName || `用户${item.roleId}`,
              roleId: item.roleId
            }));
          } else if (Array.isArray(res.data)) {
            this.roleList = res.data.filter(item => item.roleId).map(item => ({
              id: item.id,
              accountName: item.accountName || `用户${item.roleId}`,
              roleId: item.roleId
            }));
          }
          this.roleList.sort((a, b) => {
            if (a.accountName < b.accountName) return -1;
            if (a.accountName > b.accountName) return 1;
            return 0;
          });
        } else {
          this.roleList = [];
        }
      }).catch(() => { this.roleList = []; });
    },

    loadLogTypes() {
      request.get("/xyzwws/websocket/logType").then(res => {
        if (res.code === '0' && res.data) {
          this.logTypeOptions = Object.entries(res.data).map(([value, label]) => ({
            value: parseInt(value),
            label: label
          }));
          this.logTypeOptions.sort((a, b) => a.value - b.value);
          this.logTypeMap = res.data;
        } else {
          this.setDefaultLogTypes();
        }
      }).catch(() => { this.setDefaultLogTypes(); });
    },

    setDefaultLogTypes() {
      this.logTypeOptions = [
        {label: '未知', value: 0}, {label: '收菜', value: 1}, {label: '踢人/申请', value: 2},
        {label: '人员同步', value: 3}, {label: '盐场同步', value: 4}, {label: '宝库助力', value: 5},
        {label: '俱乐部签到', value: 6}, {label: '改阵容名称', value: 7}, {label: '每日任务', value: 8},
        {label: '赛车', value: 9}, {label: '梦境', value: 10}, {label: '竞技场', value: 11},
        {label: '怪异塔', value: 12}, {label: '咸将塔', value: 13}, {label: '限时活动', value: 15}
      ];
      this.logTypeMap = {};
      this.logTypeOptions.forEach(item => { this.logTypeMap[item.value] = item.label; });
    },

    formatLogType(row, column, cellValue) {
      return this.logTypeMap[cellValue] || `未知类型(${cellValue})`;
    },

    resetData() {
      this.search = { roleId: '', logType: '', error: '' }
      this.currentPage = 1;
      this.load();
    },

    load() {
      this.loading = true;
      const params = { current: this.currentPage, size: this.pageSize };
      if (this.search.roleId !== '' && this.search.roleId !== undefined && this.search.roleId !== null) {
        params.roleId = this.search.roleId;
      }
      if (this.search.logType !== '' && this.search.logType !== undefined && this.search.logType !== null) {
        params.logType = this.search.logType;
      }
      if (this.search.error !== '' && this.search.error !== undefined && this.search.error !== null) {
        params.error = this.search.error;
      }

      request.get("/wsLog/list", { params: params }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },

    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    },
  }
}
</script>

<style scoped>
/* PC端/移动端显示控制 */
.search-mobile, .table-mobile, .pagination-mobile {
  display: none;
}

.search-pc .el-select {
  margin-right: 10px;
}

/* 移动端搜索样式 */
.search-mobile .search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}

.search-mobile .search-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
}

.search-mobile .search-content .el-select {
  width: 100%;
}

.search-mobile .search-btns {
  display: flex;
  gap: 10px;
}

.search-mobile .search-btns .el-button {
  flex: 1;
}

/* 移动端卡片样式 */
.card-item {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 10px;
}

.card-row {
  display: flex;
  padding: 5px 0;
  font-size: 14px;
}

.card-label {
  color: #909399;
  width: 60px;
  flex-shrink: 0;
}

.card-value {
  color: #303133;
  flex: 1;
  word-break: break-all;
}

.card-value.content-text {
  font-size: 13px;
  line-height: 1.5;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .search-pc, .table-pc, .pagination-pc {
    display: none !important;
  }
  .search-mobile, .table-mobile, .pagination-mobile {
    display: block !important;
  }
  
  /* 暗色模式 */
  .search-mobile .search-header {
    background: #2a2a2a;
    color: #e6a23c;
    border: 1px solid #3a3a3a;
  }
  
  .search-mobile .search-content {
    background: #1a1a1a;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  
  .card-item {
    background: #2a2a2a;
    border: 1px solid #3a3a3a;
  }
  
  .card-label {
    color: #909399;
  }
  
  .card-value {
    color: #e6a23c;
  }
  
  .card-value.content-text {
    color: #c0c4cc;
  }
}
</style>
